import { useMemo } from 'react';

import * as Styled from 'approot/activity-builder/components/teaching-notes/teaching-notes-detail-question.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button';
import { LEARNING_SEQUENCE_ITEM_TYPE_QUESTION } from 'global/constants';
import { Detail } from 'approot/activity-builder/components/teaching-notes/teaching-notes.constants';
import { SectionOrSubSectionOverview } from 'approot/activity-builder/activity-builder.constants';
import IconArrowLeft from 'approot/shared/icons/icon-arrow-left';

const TeachingNotesDetailQuestionFooter = ({
  sectionId,
  sectionsAndSubSectionsOverview,
  onClick,
}: {
  sectionId: string;
  sectionsAndSubSectionsOverview: SectionOrSubSectionOverview[];
  onClick: (detail: Detail) => void;
}) => {
  const sortedSectionAndSubsectionIds = useMemo(
    () => sectionsAndSubSectionsOverview.map(section => section.id),
    [sectionsAndSubSectionsOverview]
  );

  const isFirstSection = useMemo(
    () => sectionId === sortedSectionAndSubsectionIds?.[0],
    [sectionId, sortedSectionAndSubsectionIds]
  );

  const isLastSection = useMemo(
    () => sectionId === sortedSectionAndSubsectionIds?.at(-1),
    [sectionId, sortedSectionAndSubsectionIds]
  );

  const number = useMemo(() => {
    return sortedSectionAndSubsectionIds.findIndex(id => id === sectionId) + 1;
  }, [sectionId, sortedSectionAndSubsectionIds]);

  return (
    sortedSectionAndSubsectionIds &&
    sortedSectionAndSubsectionIds.length > 0 && (
      <Styled.DetailQuestionFooter>
        <Box $gap={spacing8}>
          {!isFirstSection && (
            <SecondaryButtonIcon
              type="button"
              aria-label="Previous slide"
              onClick={() => {
                const previousNumber = number - 1;
                const sectionId =
                  sortedSectionAndSubsectionIds[previousNumber - 1];

                onClick({
                  type: LEARNING_SEQUENCE_ITEM_TYPE_QUESTION,
                  sectionId,
                });
              }}
            >
              <IconArrowLeft />
            </SecondaryButtonIcon>
          )}
          <PrimaryButton
            type="button"
            disabled={isLastSection}
            aria-label="Next slide"
            onClick={() => {
              const nextNumber = number + 1;
              const sectionId = sortedSectionAndSubsectionIds[nextNumber - 1];

              onClick({
                type: LEARNING_SEQUENCE_ITEM_TYPE_QUESTION,
                sectionId,
              });
            }}
          >
            Next
          </PrimaryButton>
        </Box>
      </Styled.DetailQuestionFooter>
    )
  );
};

export default TeachingNotesDetailQuestionFooter;
